








































































import { defineComponent, ref, PropType, computed, toRefs, watch } from '@vue/composition-api';
import VirtualList from 'vue-virtual-scroll-list';
import messageEventSetListItem from './item.vue';
import SelectListOperator from '@/components/common/select-list-operator/index.vue';
import DropdownPanel from '@/components/common/dropdown-panel/index.vue';
import EmptyContent from '@/components/common/empty-content/index.vue';
import { i18n } from './../../../../i18n';
import { Validator } from '@tt4b/ttam-hooks';
import { MessageEventSetItem } from '@tt4b/ttam-enums';
import { useMessageEventSetDisplayList } from '../hooks';

const name = 'ttam-message-event-set-list';
export default defineComponent({
  name,
  components: {
    VirtualList,
    SelectListOperator,
    DropdownPanel,
    EmptyContent,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String as PropType<string>,
      default: i18n.t('creation_message_event_set_placeholder'),
    },
    list: {
      type: Array as PropType<MessageEventSetItem[]>,
      default: () => [],
    },
    value: {
      type: String as PropType<string>,
      default: '',
    },
    addUrl: {
      type: String as PropType<string>,
      default: '',
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    validator: {
      type: Array as PropType<Validator>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { list } = toRefs(props);
    const { keywords, filterList } = useMessageEventSetDisplayList(list);
    const popperVisible = ref(false);
    const inputRef = ref();
    const dropDownMaxHeight = ref(0);
    const currentItem = computed<MessageEventSetItem>(
      () => props.list.find(i => i.id === props.value) ?? ({} as MessageEventSetItem),
    );
    const handleClick = (i: MessageEventSetItem) => {
      popperVisible.value = false;
      emit('change', i);
    };
    const handleClose = () => {
      popperVisible.value = false;
    };
    const handleRefresh = () => {
      emit('refresh');
      inputRef.value?.focus?.();
    };

    const handleAdd = () => {
      emit('add');
      handleClose();
    };

    const messageEventSetName = computed(() => currentItem.value?.name ?? '');

    const setDropdownMaxHeight = () => {
      // dropdown-panel 的触底计算有问题
      // NOTE: 这里计算下拉框最大高度，如果需要修改 css 的时候记得关注这一块
      const optionLength = list.value.length;
      const optionHeight = 54;
      const extraHeight = 34 + 34 + 12; // 包括 searchInput、optBar 以及 padding
      const emptyHeight = 240;
      const maxHeight = 274;
      const creationButtonHeight = 60;
      const totalHeight = optionLength ? optionLength * optionHeight + extraHeight : emptyHeight;
      // 需要把 creation 底部的操作栏加上，否则会被遮挡
      dropDownMaxHeight.value = creationButtonHeight + (totalHeight > maxHeight ? maxHeight : totalHeight);
    };

    watch(popperVisible, val => {
      if (!val) {
        keywords.value = '';
      } else {
        setDropdownMaxHeight();
      }
    });

    return {
      name,
      inputRef,
      messageEventSetName,
      currentItem,
      popperVisible,
      keywords,
      filterList,
      dropDownMaxHeight,
      messageEventSetListItem,
      handleClick,
      handleClose,
      handleRefresh,
      handleAdd,
    };
  },
});
